module.exports = __webpack_public_path__ + "static/ReaderExperience-fbc09bc6149ed322bd74ea5a5bf07836.png";